import React from 'react';

import { Glyph } from './PlayersGlyph.styles';

/**
 * "Players" nav glyph — a two-person (users) mark, drawn inline (not via `<img>`)
 * so the nav's active/hover `path[fill]` rule can recolour it (there is no CDN
 * icon for this page; the mask-based `MaskIcon` glyphs recolour via background-color).
 *
 * The path is `fill="currentColor"`: the rest colour comes from the nav-icon token
 * on the `Glyph` wrapper, the active colour from the parent nav item's recolour
 * rule. The wrapper renders an svg sized by the `.icon svg` / `.drawer-icon
 * svg` rules unchanged. Geometry is the Heroicons "users" (solid).
 */
export type PlayersGlyphProps = {
  size?: number;
  className?: string;
};

export const PlayersGlyph = ({ size = 24, className }: PlayersGlyphProps): React.ReactElement => (
  <Glyph className={className} aria-hidden="true">
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        fill="currentColor"
        d="M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.128l-.001.144a2.25 2.25 0 0 1-.233.96 10.088 10.088 0 0 0 5.06-1.01.75.75 0 0 0 .42-.643 4.875 4.875 0 0 0-6.957-4.611 8.586 8.586 0 0 1 1.71 5.157v.003Z"
      />
    </svg>
  </Glyph>
);

export default PlayersGlyph;
